import { getField, updateField } from 'vuex-map-fields';
import * as model  from "@/model/adm/IntegrationMessage";
import { newEntityStoreHelper } from "@/store/common/entityModule";
import _ from 'lodash'

const filter = model.filter;

function newFilter(paginationFilter = {}) {
    return Object.assign({}, paginationFilter, filter);
}
const baseStore = newEntityStoreHelper(() => new model.Model(), newFilter).buildStore();
 
const state = {
    baseModuleUrl : process.env.VUE_APP_ADM_API_URL + "adm-service/adm",
    rows: [],
    filter,
    crudState: 'list',
    checkedItems: []
};
//TODO find a better way to cleanup the filter
//const filterDefault = Object.assign({}, filter);
const filterDefault = JSON.parse(JSON.stringify(filter));

const getters = {
    getField,
    checkedItems: state =>{ 
        return state.checkedItems
    },
    getCheckedItems: state =>{ 
        return state.checkedItems
    }
};

const actions = {
    reprocessMessage(context) {
        var auxArray =  [...context.state.checkedItems];

        if( auxArray.length < 1  )
            return;

        context.dispatch("api/post", {
            url: "integrationMessage/reprocessMensages/", 
            data: auxArray
        }, {root: true})
        .then(function(){
            context.dispatch("base/showSuccess", {
                userAlertSuccessStr: "Reprocessed",
                dismissCountDown: 5,
                userAlertSuccessVisible: false,
                }, {root: true}).then(function(){ // doing search again
                    context.dispatch("base/MMFLoadRows", 'integrationMessage', {root: true});
                })
        });
    }
};
const mutations = {
    updateField,
    setRows(state, rows) {
        state.rows = rows;
    },
    setCrudState(state, crudState) {
        state.crudState = crudState;
    },
    setEntity(state, entity) {
        state.entity = entity;
    },
    setClearFilter(state) {
        //TODO find a better way to cleanup the filter
        state.filter = filterDefault;
    },
    setCheckedItems(state, checkedItems) {
        state.checkedItems = checkedItems;
    },
    checkedItems(state, checkedItems) {
        state.checkedItems = checkedItems;
    }
};

const integrationMessage = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default _.defaultsDeep(integrationMessage, baseStore)